<template lang="pug">
.map-offcanvas__item
  .map-offcanvas__title
    span(uk-icon="icon: location; ratio: .7")
    div &nbsp;操作

  .map-offcanvas__body
    .uk-grid-small.uk-flex.uk-flex-middle.uk-flex-between.uk-flex-wrap.uk-child-width-1-1(
      class="uk-child-width-auto@m",
      uk-grid
    )
      div
        a.uk-button.uk-border-rounded.uk-width-1-1.uk-button-primary(
          href="#",
          @click.prevent="goToCurrent",
          style="padding: 5px 10px",
          :disabled="!current_position",
          :class="!current_position ? 'uk-button-default' : 'uk-button-primary'",
          :style="`opacity: ${!current_position ? .5 : 1}`"
        )
          .uk-text-small 現在位置

      div
        a.uk-button.uk-border-rounded.uk-button-primary.uk-width-1-1(
          href="#",
          @click.prevent="handleToggleGuide",
          style="padding: 5px 10px",
        )
          .uk-text-small 凡例
            span(v-if="guide_is_show") 非表示
            span(v-else) 表示

      div
        a.uk-button.uk-button-primary.uk-border-rounded.uk-width-1-1(
          href="#",
          @click.prevent="handlePrint",
          style="padding: 5px 10px"
        )
          .uk-text-small 印刷
</template>

<script>
import * as types from '../js/mutations/map-mutations'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['current_position', 'guide_is_show']),
  },

  methods: {
    goToCurrent () {
      this.$store.dispatch(types.SET_CURRENT_POSITION)
    },

    handleToggleGuide () {
      this.$store.dispatch(types.TOGGLE_GUIDE)
    },

    handlePrint () {
      print()
    },
  }
}

</script>
